export default __webpack_public_path__ + "f958c681d7293226a31914e27c15cc83.ttf";